export default class Modal {
    constructor() {
        this.init();
    }

    init() {
        this.eventBind();
    }

    eventBind() {
        const openbuttons = [...document.querySelectorAll(".js-modal-open")];
        const closebuttons = [...document.querySelectorAll(".js-modal-close")];
        const modals = [...document.querySelectorAll(".js-modal:not(.js-moviemodal)")];
        document.querySelectorAll(".js-modal").forEach((modal) => {
            modal.setAttribute("data-lenis-prevent", "");
        });

        openbuttons.forEach((el) => {
            el.addEventListener("click", (e) => {
                e.preventDefault();
                const modalID = el.getAttribute("data-modalID");
                const tgtmodal = document.querySelector(`.js-modal[data-modalID=${modalID}]`);

                if (tgtmodal) {
                    this.replayApng(tgtmodal);
                    tgtmodal.classList.add("-active");
                }

                document.body.classList.add("-inmodal");
            });
        });

        closebuttons.forEach((el) => {
            el.addEventListener("click", () => {
                const tgtmodal = el.closest(".-active");
                this.close(tgtmodal);
            });
        });

        modals.forEach((modal) => {
            modal.addEventListener("click", (e) => {
                if (e.target.closest(".js-modal-ignore-close") || e.target.closest(".js-modal-close")) return;
                this.close(modal);
            });
        });
    }

    close(modal) {
        if (!modal) return;

        modal.classList.remove("-active");
        document.body.classList.remove("-inmodal");
    }

    replayApng(modal) {
        const apngImgs = modal.querySelectorAll(".js-modal-apng img[data-src]");

        apngImgs.forEach((img) => {
            const src = img.dataset.src;
            if (!src) return;

            const clone = img.cloneNode(true);
            clone.removeAttribute("src");
            img.replaceWith(clone);

            requestAnimationFrame(() => {
                const separator = src.includes("?") ? "&" : "?";
                clone.src = `${src}${separator}apng=${Date.now()}`;
            });
        });
    }
}
